export const MAIN_TO_RENDERER_MONITORING_ANALYTICS_LOG_DATA =
  'MAIN_TO_RENDERER_MONITORING_ANALYTICS_LOG_DATA';
